import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { BaseService } from './base.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { FieldMapCostModel, CostUpsertRequest, CostBatchRequest, CostBatchResponse } from '../models/season-models/field-map-cost-model';
import { CostUnitOfMeasureModel } from '../models/season-models/cost-unit-of-measure-model';

@Injectable({
    providedIn: 'root'
})
export class CostService extends BaseService {

    private API_COST_URL = this.API_BASE_URLv4 + 'season-management/costs';

    constructor(
        private httpClient: HttpClient,
        public _snackBar: MatSnackBar,
        public translate: TranslateService
    ) {
        super();
    }

    getCosts(seasonFieldDetailId: number): Observable<FieldMapCostModel[]> {
        return this.httpClient.get<FieldMapCostModel[]>(this.API_COST_URL + '/' + seasonFieldDetailId)
            .pipe(
                retry(1),
                catchError(err => {
                    this._snackBar.open(this.translate.instant('COST.ERROR_LOADING'), this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
                    return this.errorHandler(err);
                })
            );
    }

    getCostsByCategory(seasonFieldDetailId: number, category: string): Observable<FieldMapCostModel[]> {
        return this.httpClient.get<FieldMapCostModel[]>(this.API_COST_URL + '/' + seasonFieldDetailId + '?category=' + category)
            .pipe(
                retry(1),
                catchError(err => {
                    this._snackBar.open(this.translate.instant('COST.ERROR_LOADING'), this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
                    return this.errorHandler(err);
                })
            );
    }

    upsertCost(request: CostUpsertRequest): Observable<FieldMapCostModel> {
        return this.httpClient.put<FieldMapCostModel>(this.API_COST_URL, request)
            .pipe(
                catchError(err => {
                    this._snackBar.open(this.translate.instant('COST.ERROR_SAVING'), this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
                    return this.errorHandler(err);
                })
            );
    }

    getUnitsOfMeasure(): Observable<CostUnitOfMeasureModel[]> {
        return this.httpClient.get<CostUnitOfMeasureModel[]>(this.API_COST_URL + '/unit-of-measure')
            .pipe(
                retry(1),
                catchError(err => {
                    this._snackBar.open(this.translate.instant('COST.ERROR_LOADING'), this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
                    return this.errorHandler(err);
                })
            );
    }

    batchUpdateCosts(request: CostBatchRequest): Observable<CostBatchResponse> {
        return this.httpClient.put<CostBatchResponse>(this.API_COST_URL + '/batch', request)
            .pipe(
                catchError(err => {
                    this._snackBar.open(this.translate.instant('COST.ERROR_BATCH'), this.translate.instant('SNACKBAR.DISMISS'), { duration: 5000 });
                    return this.errorHandler(err);
                })
            );
    }

    getInputOptions(seasonFieldDetailId: number): Observable<any[]> {
        return this.httpClient.get<any[]>(this.API_COST_URL + '/input-options/' + seasonFieldDetailId)
            .pipe(
                retry(1),
                catchError(err => {
                    return this.errorHandler(err);
                })
            );
    }
}
